export const SESSION_PERSISTENCE = 1000 * 60 * 60 * 24 * 30 * 3; //3 months
export const SESSION_TIMEOUT = 1000 * 60 * 30; // 30 mins
